module.exports = __webpack_public_path__ + "static/media/Archen_gaussian2.55cb4a68.png";